import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceTemplate, ServiceTemplateService } from '@netfoundry-ui/shared/service-templates';
import { Subscription } from 'rxjs';

/**
 * The "From Template" card on /services/select. Unlike the shared, purely
 * presentational netfoundry-ui-service-card (fixed absolute-positioned
 * layout, whole-card click target), this card owns its own state so it can
 * load templates and host an inline picker + Create action, or an
 * empty-state link to the template list when none exist yet.
 */
@Component({
    selector: 'netfoundry-ui-template-service-card',
    templateUrl: './template-service-card.component.html',
    styleUrls: ['./template-service-card.component.scss'],
    standalone: false,
})
export class TemplateServiceCardComponent implements OnInit, OnDestroy {
    templates: ServiceTemplate[] = [];

    private subscription = new Subscription();

    constructor(private router: Router, private templateService: ServiceTemplateService) {}

    ngOnInit(): void {
        this.subscription.add(this.templateService.templates$.subscribe((templates) => (this.templates = templates)));
        this.templateService.loadTemplates();
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    onCreateClicked(): void {
        this.router.navigate(['/services/template']);
    }

    goToTemplates(): void {
        this.router.navigateByUrl('/service-templates');
    }
}
